import { parse, isValid, subYears } from "date-fns";
import { UseFormSetError } from "react-hook-form";
import { FormValues } from "@/components/booking-form/types";

export const useBirthdayValidation = (
  setError: UseFormSetError<FormValues>,
) => {
  const validateBirthday = (value: string): boolean => {
    if (!value) return false;

    const date = parse(value, "dd.MM.yyyy", new Date());
    if (!isValid(date)) {
      setError("birthday", {
        type: "manual",
        message: "Please enter a valid date in format DD.MM.YYYY",
      });
      return false;
    }

    const today = new Date();
    const minAge = subYears(today, 18);
    const maxAge = subYears(today, 150);

    if (date > today) {
      setError("birthday", {
        type: "manual",
        message: "Birthday cannot be in the future",
      });
      return false;
    }

    if (date > minAge) {
      setError("birthday", {
        type: "manual",
        message: "You must be at least 18 years old",
      });
      return false;
    }

    if (date < maxAge) {
      setError("birthday", {
        type: "manual",
        message: "Sorry, longevity science hasn't progressed that much yet! 😅",
      });
      return false;
    }

    return true;
  };

  return { validateBirthday };
};
